/**
 * Simple window ponyfill
 * Exports window if available, otherwise a mock object for SSR/testing
 */

const mockWindow = {
  innerWidth: 1024,
  confirm: () => true,
}

export const windowPonyfill = typeof window === 'object' ? window : mockWindow
